import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    userId: Number,
    toUserId: Number,
    service: String
  }

  connect() {
    // Если не залогинен, то открываем пост и больше ничего не делаем
    if (Number(document.body.dataset.currentUserId) == 0) { this.disclosePost(); return }

    if (['default', 'telegram', 'youtube', 'poll'].includes(this.serviceValue)) { this.processDefaultIgnores() }
    if (this.serviceValue == 'premia-vote') { this.processPremiaIgnore() }
    if (this.serviceValue == 'vulich-vote') { this.processVulichIgnore() }
  }

  processDefaultIgnores() {
    // Если это мой пост, то сразу его показываем и больше ничего не делаем
    if (Number(document.body.dataset.currentUserId) == this.userIdValue) { this.disclosePost(); return }

    const ignoredUserIds = document.body.dataset.ignoredUserIds
    const ultraIgnoredUserIds = document.body.dataset.ultraIgnoredUserIds

    const parseIds = (ids) => ids ? ids.split(' ').map(Number) : []

    const ignoredUserIdsArray = parseIds(ignoredUserIds)
    const ultraIgnoredUserIdsArray = parseIds(ultraIgnoredUserIds)

    const isHidden = ignoredUserIdsArray.includes(this.userIdValue) || ultraIgnoredUserIdsArray.includes(this.toUserIdValue)

    if (!isHidden) { this.disclosePost() }
  }

  processPremiaIgnore() {
    if (document.body.dataset.premiaShow == 'true') { this.disclosePost() }
  }

  processVulichIgnore() {
    if (document.body.dataset.vulichShow == 'true') { this.disclosePost() }
  }

  disclosePost() {
    this.element.classList.remove('hidden')
  }
}
